import { getW } from 'Lib/w/w';
import { eksmoBP } from 'Lib/bp/bp';
import 'imports-loader?wrapper=window!jquery-throttle-debounce'; // eslint-disable-line import/no-extraneous-dependencies, import/no-webpack-loader-syntax
import { isTouch } from 'Lib/istouch/istouch';
import { onScreen } from 'Lib/on-screen/on-screen';
import { Popup } from 'Lib/popup/popup';
import './include/tags';
import './include/analitics';
import './include/livelib-reviews';
import './include/reader';
import './include/mobile-swipe-book';
// import './include/promocode'; Скрываем до появления новой ЧГ корзины
import './include/play-annotation';
import './include/wholesale-btn';
import './include/separate-reader-text';

const $tip = $('.book-page__tip-social-proof');
const elLivelibRatingPopupBtn = document.querySelector('.book-page__livelib');

// Tip social proof
if ($tip.length === 1) {
    setTimeout(() => {
        $tip.show();
    }, 2000);

    $tip.on('click', () => {
        $tip.hide();
    });
}

// Variable bg section
$('.book-page__section_variable-bg').filter(':even').each(function () {
    $(this).addClass('bg bg_static bg_white');
});

// Подмена картинок фона на десктопе в блоке book-page__banner
onScreen($('.book-page__banner'), ($el) => {
    const bgMobile = $el.attr('data-bg-mobile');

    if (getW() < eksmoBP.smMin && bgMobile) {
        $el.attr('style', `background-image:url("${bgMobile}")`);
    } else {
        $el.attr('style', `background-image:url("${$el.attr('data-bg')}")`);
    }
});

// Livelib init
if (elLivelibRatingPopupBtn) {
    if (getW() < eksmoBP.mdMax || isTouch()) {
        elLivelibRatingPopupBtn.setAttribute('data-fancybox', '');
        elLivelibRatingPopupBtn.setAttribute('data-src', '#livelib-rating_popup');

        elLivelibRatingPopupBtn.addEventListener('click', () => {
            document.dispatchEvent(new CustomEvent('init.livelibRating.eksmo'));
        });
    } else {
        elLivelibRatingPopupBtn.classList.add('js-anchor-link');
        elLivelibRatingPopupBtn.setAttribute('href', '#reviews-livelib');
        elLivelibRatingPopupBtn.setAttribute('data-minus', '60');
        elLivelibRatingPopupBtn.classList.add('link-drop-down');

        elLivelibRatingPopupBtn.addEventListener('mouseenter', () => {
            document.dispatchEvent(new CustomEvent('init.livelibRating.eksmo'));
        });
    }

    onScreen($('.livelib-rating_page'), () => {
        document.dispatchEvent(new CustomEvent('init.livelibRating.eksmo'));
    });
} else {
    document.querySelector('.livelib-rating_page')?.classList.add('livelib-rating_page_inactive');
}
//

// Иконка благотворительности на обложке: попап в мобильной версии
const $cmenu = $('.cmenu').first();

$cmenu.find(`.cmenu__item.link-drop-down`).on('eksmoLinkDropDown', (e, isShow) => {
    $('.book-page__shield-charity-box').toggleClass('book-page__shield-charity-box_z-index1', isShow);
});

if (getW() < eksmoBP.mdMin) {
    const elShieldCharityPopup = document.querySelector('.book-page__shield-charity-popup');
    const popup = new Popup('popup', elShieldCharityPopup);

    document.querySelector('.book-page__shield-charity-tip')?.remove();

    document.querySelector('.book-page__shield-charity-box')?.addEventListener('click', () => {
        popup.open(true);
    });
}
//

// Табы категорий отзывов
function switchTabReviews(item, i) {
    document.querySelectorAll('.book-page__tabs-reviews-container').forEach((itemCont) => {
        itemCont.classList.remove('book-page__tabs-reviews-container_active');
    });

    document.querySelectorAll('.book-page__tabs-reviews-link').forEach((itemLink) => {
        itemLink.classList.remove('book-page__tabs-reviews-link_active');
    });

    item.classList.add('book-page__tabs-reviews-link_active');
    document.querySelectorAll('.book-page__tabs-reviews-container')[i].classList.add('book-page__tabs-reviews-container_active');
    $('body').trigger('toggle.tabsBookPageReviews.eksmo', [$('.book-page__tabs-reviews-container_active')]);
}

document.querySelectorAll('.book-page__tabs-reviews-link').forEach((item, i) => {
    item.addEventListener('click', () => {
        switchTabReviews(item, i);
    });
});

document.querySelectorAll('[href="#reviews"]').forEach((item) => {
    item.addEventListener('click', () => {
        switchTabReviews(document.querySelector('.book-page__tabs-reviews-link'), 0);
    });
});